<template>
    <app-tabela
        :itens="rateios"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="true"
    >
        <template slot="nuValorRateio" slot-scope="data">{{
            data.nuValorRateio | currency
        }}</template>
        <template slot="unidade" slot-scope="data"
            >({{ data.codUnidade }}) {{ data.unidade }}</template
        >
        <template slot="projeto" slot-scope="data"
            >({{ data.codProjeto }}) {{ data.projeto }}</template
        >
        <template slot="acao" slot-scope="data"
            >({{ data.codAcao }}) {{ data.acao }}</template
        >
    </app-tabela>
</template>

<script>
export default {
    props: {
        rateios: {
            type: Array,
            default: () => []
        },

        valorASerRateado: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuValorRateio',
                    label: 'Valor',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0
        }
    }
}
</script>
